export default __webpack_public_path__ + "static/media/add-circle.31caa548.svg";